module.exports = __webpack_public_path__ + "static/img/secrecy.ba164b36.png";